import React from 'react';

const ZipContext = React.createContext({ zip: null, club: null, fullAccess: null, setZip: () => {} });

export default ZipContext;
